import { render } from "./NewRegister.vue?vue&type=template&id=005a642b"
import script from "./NewRegister.vue?vue&type=script&lang=js"
export * from "./NewRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__